import React from 'react';
import { NumberInput, useResourceContext } from 'react-admin';
import useCheckAccess from 'hooks/useCheckAccess';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { MARKUP_APPLICABLE_LEVELS } from '../../constants/tax-classification';

type Props = {
  source: string;
  field: string;
  label: string;
  inheritedSettings: Record<string, any>;
  parentSettings: Record<string, any>;
  taxClassification: string;
};

export const MarkupInput = ({
  source,
  field,
  label,
  inheritedSettings,
  taxClassification,
  parentSettings,
}: Props) => {
  const resource = useResourceContext();
  const checkAccess = useCheckAccess();
  const isMarkupApplicable = MARKUP_APPLICABLE_LEVELS.includes(resource);
  const editable = isMarkupApplicable && checkAccess('update', resource, field);
  const helperText = String(
    getInheritedValue(inheritedSettings, `${taxClassification}.${field}`, parentSettings) ?? '',
  );

  return (
    <NumberInput
      source={`${source}.${field}`}
      label={label}
      disabled={!editable}
      helperText={helperText}
    />
  );
};
